import { MarkdownContent } from "@repo/ui/markdown/markdownContent";
import { DefaultSkeleton } from "@repo/ui/Skeletons/skeletons";
import type { FC } from "react";
import { twMerge } from "tailwind-merge";

export interface TeammateAccountRecordingsSummaryProps {
  summary: string | null;
  isLoading?: boolean;
}

export const TeammateAccountRecordingsSummary: FC<
  TeammateAccountRecordingsSummaryProps
> = (props) => {
  const { summary } = props;

  if (props.isLoading) {
    return (
      <div className="p-4">
        <DefaultSkeleton />
      </div>
    );
  }

  if (!summary) {
    return null;
  }

  return (
    <div className="px-4 pt-1">
      <div
        className={twMerge(
          "prose prose-sm max-w-none text-sm leading-relaxed transition-colors duration-200",
          "prose-headings:mt-3 prose-headings:mb-2 prose-headings:text-sm prose-headings:font-medium",
          "prose-p:mb-2 prose-p:text-sm prose-p:leading-relaxed",
          "prose-ul:mb-2 prose-ul:text-sm prose-ul:leading-relaxed",
          "prose-ol:mb-2 prose-ol:text-sm prose-ol:leading-relaxed",
          "prose-li:text-sm prose-li:leading-relaxed",
          "prose-gray",
        )}
      >
        <MarkdownContent>{summary}</MarkdownContent>
      </div>
    </div>
  );
};
